module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_f_albino.d8bfc972.png";